const langIt_migross_cash_and_carry = {
  "df-store-card.store-selection": "Scegli il punto vendita",
  "df-section-promotions.title.flyer": "Scopri le nostre promozioni",
  "df-section-promotions.title.catalog": "Scopri i nostri cataloghi",
};

export default langIt_migross_cash_and_carry;
